import { CREATE_DMX_DEVICE_PRESET, CREATE_DMX_DEVICE_PRESET_SUCCESSFUL, CREATE_DMX_DEVICE_PRESET_FAILED } from './actionTypes';

const initialState = {
  createDmxDevicePresetError: null,
  messageDmxDevicePreset: null,
  loadingCreateDmxDevicePreset: false,
};

const createDevicePreset = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_DMX_DEVICE_PRESET:
      state = { ...state, loadingCreateDmxDevicePreset: true, createDmxDevicePresetError: null };
      break;
    case CREATE_DMX_DEVICE_PRESET_SUCCESSFUL:
      state = { ...state, loadingCreateDmxDevicePreset: false, messageDmxDevicePreset: action.payload, createDmxDevicePresetError: null };
      break;
    case CREATE_DMX_DEVICE_PRESET_FAILED:
      state = { ...state, messageDmxDevicePreset: null, loadingCreateDmxDevicePreset: false, createDmxDevicePresetError: action.payload };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default createDevicePreset;
